export interface YearStats {
  positiveDots: number;
  negativeDots: number;
  inflow: number;
  outflow: number;
}

export interface MigrationManifest {
  generatedAt: string;
  estimatesVintage: number;
  boundaryVintage: number;
  peoplePerDot: number;
  years: number[];
  defaultYear: number;
  countyCount: number;
  stats: Record<string, YearStats>;
  source: string;
}

export interface CountyProperties {
  fips: string;
  county: string;
  state: string;
  population: number;
  /** Net domestic migration per year, stored as `mig2021`, `mig2022`, ... */
  [migYear: string]: string | number;
}

/** Read the net-migration value for a given year off a county's properties. */
export function countyMigration(props: CountyProperties, year: number): number {
  const value = props[`mig${year}`];
  return typeof value === 'number' ? value : Number(value ?? 0) || 0;
}

export type DotSign = 'pos' | 'neg';
